import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const InputValidIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M22.703 5.71 7.853 20.408l-6.556-6.49 1.406-1.42 5.15 5.096L21.298 4.29l1.406 1.422Z" />
  </IconWrapper>
)

export default InputValidIconMedium
